import Vue from 'vue'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'
import router from '@/router/'

// load analytics/tracking only on Live/prod
if (process.env.VUE_APP_LIVE === 'true') {
  // GTM init & config
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID, // Your GTM ID
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
  })

  // GA4
  Vue.use(
    VueGtag,
    {
      config: { id: process.env.VUE_APP_GA4_ID },
      pageTrackerScreenviewEnabled: true,
    },
    router
  )
}
